import React from "react";

/**
 * NoResults information
 *
 * @component NoResults
 *
 */
const NoResults = () => {
  return (
    <div className="404">
      <h1 className="future glow">404</h1>
      <h3>No Page Found</h3>
    </div>
  );
};

export default NoResults;
